import { Form, Input, Select, Switch } from 'antd';
import React from 'react';
import { IdefaultVendor } from './Vendor';

interface VendorGeneralInfoCollapsibleProps {
  vendorDetails: IdefaultVendor;
  onChange: (key: string, value: any) => void;
}

type FieldType = {
  vendor_name?: string;
  vendor_model?: string;
  equipment_type?: string;
  child_equipment_type?: string;
  has_cable_modem?: boolean;
};

const VendorGeneralInfoCollapsible: React.FC<VendorGeneralInfoCollapsibleProps> = ({ vendorDetails, onChange }) => {
  const handleChange = (key: string, value: any) => {
    onChange(key, value);
  };

  return (
    <Form
      name="basic"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 24 }}
      initialValues={{
        vendor_name: vendorDetails.vendor_name,
        vendor_model: vendorDetails.vendor_model,
        equipment_type: vendorDetails.equipment_type,
        child_equipment_type: vendorDetails.child_equipment_type,
        has_cable_modem: vendorDetails.has_cable_modem,
      }}
      autoComplete="off">
      <Form.Item<FieldType> label="Vendor Name" name="vendor_name" rules={[{ required: true, message: 'Please provide vendor name!' }]}>
        <Input onChange={(e) => handleChange('vendor_name', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="Vendor Model" name="vendor_model" rules={[{ required: true, message: 'Please provide vendor model!' }]}>
        <Input onChange={(e) => handleChange('vendor_model', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="Equipment Type" name="equipment_type" rules={[{ required: false }]}>
        <Select
          getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
          }}
          options={[]}
          onChange={(value) => handleChange('equipment_type', value)}
        />
      </Form.Item>
      <Form.Item<FieldType> label="Child Equipment Type" name="child_equipment_type" rules={[{ required: false }]}>
        <Select
          getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
          }}
          options={[]}
          onChange={(value) => handleChange('child_equipment_type', value)}
        />
      </Form.Item>
      <Form.Item<FieldType> label="Has Cable Modem" name="has_cable_modem" rules={[{ required: false }]}>
        <Switch
          checkedChildren="Yes"
          unCheckedChildren="No"
          defaultChecked={vendorDetails.has_cable_modem}
          onChange={(e) => handleChange('has_cable_modem', e)}
        />
      </Form.Item>
    </Form>
  );
};

export default VendorGeneralInfoCollapsible;
